
export class LookupModel<T> {
    value: T | undefined;
    label: string  = '';
    id: string | undefined;
    imageUrl: string = '';
    url: string = '';
    status: string = '';
    meta_1: string = '';

    constructor(init?: Partial<LookupModel<T>>) {
        if (init) {
            Object.assign(this, init);
        }
    }
}
